<template>
    <div id="app">
        <Menu />
        <TabManager />
        <ModalOpenFile />
    </div>
</template>

<script>
    import TabManager from './Components/TabManager'
    import ModalOpenFile from './Components/ModalOpenFile'
    import Menu from './Components/Menu/Menu'

    export default {
        name: 'app',
        components: {
            TabManager,
            Menu,
            ModalOpenFile
        },
        created () {
            let val = localStorage.getItem('psflex_conf_autocomplete')
            if (val !== null) {
                this.config.autocomplete = val
            }
            val = localStorage.getItem('psflex_conf_casesensitive')
            if (val === null) {
                this.config.caseSensitive = val
            }
        },
        data () {
            return {
                config: {
                    autocomplete: true,
                    caseSensitive: true
                }
            }
        }
    }
</script>

<style>
    html, body {
        height: 100%;
    }

    body {
        font-size: 14px;
        font-family: 'Roboto', sans-serif;
        box-sizing: border-box;
        margin: 0px;
        padding: 0px;
    }
    
    #app {
        padding: 0px;
        margin: 0px;
        position: absolute;
        top: 0px;
        bottom: 0px;
        right: 0px;
        left: 0px;
        background: #F0F0F0;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue